module.exports = __webpack_public_path__ + "img/form-submit-btn.25756171.png";